import React from 'react';
import './sign-up-container.scss';
import { SVGS } from '../assets';
import { useNavigate, useLocation } from 'react-router-dom';

interface SignUpContainerProps {
  children: React.ReactNode;
  customClass?: string;
  otpScreen?: boolean;
  setShowOtpInput?: (value: boolean) => void;
  setErrorMessage?: (message: string) => void;
  setInputErrors?: (errors: { isError: boolean; errorMsg: string }) => void;
  setIsLoginScreen?: (val: boolean) => void;
}

export const SignUpContainer: React.FC<SignUpContainerProps> = ({
  children,
  customClass,
  otpScreen = false,
  setShowOtpInput,
  setErrorMessage,
  setInputErrors,
  setIsLoginScreen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginScreen = location.pathname === '/login';
  return (
    <div className={`sign-up-container primary-font-regular ${customClass}`}>
      <img
        src={SVGS.ZotokLogo}
        className="sign-up-container-img"
        alt="Zotok Logo"
      />
      {children}

      {otpScreen && (
        <div className="sign-up-container-terms-body">
          {isLoginScreen ? (
            <span
              onClick={() => {
                setErrorMessage && setErrorMessage('');
                setInputErrors &&
                  setInputErrors({
                    isError: false,
                    errorMsg: '',
                  });
                setShowOtpInput(false);
                setIsLoginScreen(false);
                navigate('/signup');
              }}
              className="sign-up-container-terms seller-font-size-medium primary-font-semibold"
            >
              Don't have an account yet!
              <a
                target="_blank"
                style={{
                  textDecoration: 'underline',
                  marginLeft: '4px',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Signup now
              </a>
            </span>
          ) : (
            <span className="sign-up-container-terms-conditions seller-font-size-medium primary-font-regular">
              <span>By proceeding, you agree to the </span>
              <span>
                <a
                  href="https://www.zotok.ai/termsandconditions"
                  target="_blank"
                >
                  Terms & Conditions
                </a>{' '}
                and{' '}
                <a
                  href="https://www.zotok.ai/termsandconditions"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </span>
            </span>
          )}
        </div>
      )}
    </div>
  );
};
